import { render, staticRenderFns } from "./WebPage.vue?vue&type=template&id=c450064e&"
import script from "./WebPage.vue?vue&type=script&lang=ts&"
export * from "./WebPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports